import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=032f6235"
import script from "./Allocations.vue?vue&type=script&lang=js"
export * from "./Allocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports